import { useQuery } from '@tanstack/react-query';
import ms from 'ms';

import { QUERY_KEYS } from 'hb-react/frontoffice/apps/Forum/constants';
import { useForumContext } from 'hb-react/frontoffice/apps/Forum/contexts/ForumContext';
import { type ConfigUrls } from 'hb-react/frontoffice/apps/Forum/types';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

interface GenerateSummaryResponse {
  content: string;
  id: number;
}

const fetchSummary = async (
  discussionId: number,
  configUrls: ConfigUrls,
): Promise<string> => {
  const response = await axios.get<GenerateSummaryResponse>(
    configUrls.getDiscussionSummaryPath(discussionId),
  );

  if (!response.data?.content) {
    throw new Error('Summary content not found in response');
  }

  return response.data.content;
};

export const useGenerateSummary = (discussionId: number) => {
  const { configUrls } = useForumContext();
  const { topicId } = useTopicContext();

  return useQuery({
    queryKey: [QUERY_KEYS.discussion, discussionId, topicId, 'ai-summary'],
    queryFn: () => fetchSummary(discussionId, configUrls),
    enabled: false,
    staleTime: ms('5m'),
  });
};
